import apiClient from "../../../utilities/apiClient";
import LocalStorage from "../../../utilities/localStorage";

export const vendor_reg = (payload) => {
  var user = LocalStorage.getItem("tata_login_user");
  const vendor_role = user.roles[0];

  return apiClient.post(
    vendor_role === "user"
      ? `${apiClient.Urls.vendor_reg}`
      : vendor_role === "officer"
      ? `${apiClient.Urls.vendor_reg_officer}`
      : `${apiClient.Urls.vendor_reg}`,
    payload,
    true,
    "file"
  );
};

export const goodsService = (payload) => {
  var user = LocalStorage.getItem("tata_login_user");
  const vendor_role = user.roles[0];
  return apiClient.get(
    vendor_role === "user"
      ? `${apiClient.Urls.goodsService}?service=${payload}`
      : vendor_role === "officer"
      ? `${apiClient.Urls.goodsServiceOfficer}?service=${payload}`
      : `${apiClient.Urls.goodsServiceAdmin}?service=${payload}`,
    "",
    true
  );
};

export const categories = (payload) => {
  var user = LocalStorage.getItem("tata_login_user");
  const vendor_role = user.roles[0];
  return apiClient.get(
    vendor_role === "user"
      ? `${apiClient.Urls.categories}?category=${payload}`
      : vendor_role === "officer"
      ? `${apiClient.Urls.categoriesOfficer}?category=${payload}`
      : `${apiClient.Urls.categoriesAdmin}?category=${payload}`,
    "",
    true
  );
};
export const getItems = (payload) => {
  var user = LocalStorage.getItem("tata_login_user");
  const vendor_role = user.roles[0];
  return apiClient.get(
    vendor_role === "user"
      ? `${apiClient.Urls.getItem}`
      : vendor_role === "officer"
      ? `${apiClient.Urls.getItemOfficer}`
      : `${apiClient.Urls.getItemAdmin}`,
    payload,
    true
  );
};

export const itemcategories = (payload) => {
  var user = LocalStorage.getItem("tata_login_user");
  const vendor_role = user.roles[0];
  return apiClient.get(
    vendor_role === "user"
      ? `${apiClient.Urls.subcategories}?subCategory=${payload}`
      : vendor_role === "officer"
      ? `${apiClient.Urls.subcategoriesOfficer}?subCategory=${payload}`
      : `${apiClient.Urls.subcategoriesAdmin}?subCategory=${payload}`,
    "",
    true
  );
};

export const contact_add = (payload) => {
  return apiClient.post(`${apiClient.Urls.contactSave}`, payload, true);
};

export const add_business_loc = (payload) => {
  var user = LocalStorage.getItem("tata_login_user");
  const vendor_role = user.roles[0];
  return apiClient.post(
    vendor_role === "user"
      ? `${apiClient.Urls.add_business}`
      : `${apiClient.Urls.add_business_officer}`,
    payload,
    true,
    "file"
  );
};

export const view_vendor_details = (payload) => {
  var user = LocalStorage.getItem("tata_login_user");
  const vendor_role = user.roles[0];

  return apiClient.get(
    vendor_role === "super admin" ||
      vendor_role === "finance" ||
      vendor_role === "Admin"
      ? `${apiClient.Urls.view_admin_details}/${payload}`
      : vendor_role === "user"
      ? `${apiClient.Urls.view_details}/${payload}`
      : `${apiClient.Urls.view_officer_details}/${payload}`,
    "",
    true
  );
};

export const vendor_reg_update = (payload) => {
  return apiClient.patch(
    `${apiClient.Urls.vendor_reg_update_v2}/${payload.vendor_id}`,
    payload,
    true,
    "file"
  );
};

export const approve_vendor = (payload) => {
  const userRole = LocalStorage.getItem("tata_login_user").roles[0];
  const tenant_id = LocalStorage.getItem("client")?.id;

  return apiClient.patch(
    userRole === "finance" && tenant_id !== 5
      ? `${apiClient.Urls.vendor_approve}/${payload.vendor_id}?type=bank`
      : tenant_id !== 5
      ? `${apiClient.Urls.vendor_approve}/${payload.vendor_id}`
      : userRole !== "officer"
      ? `${apiClient.Urls.vendor_approves}/${payload.vendor_id}`
      : `${apiClient.Urls.officer_vendor_approves}/${payload.vendor_id}`,
    payload,
    true
  );
};
export const validatePan = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.validate_pan_officer}`,
    payload,
    true
  );
};

export const createuser = (payload) => {
  return apiClient.post(`${apiClient.Urls.createuser}`, payload, true);
};

export const update_business_loc = (payload) => {
  return apiClient.patch(`${apiClient.Urls.update_business}`, payload, true);
};

export const upload_gst_doc = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.upload_gst_doc}`,
    payload,
    true,
    "file"
  );
};

export const banksApi = (payload) => {
  var user = LocalStorage.getItem("tata_login_user");
  var user_role = user.roles[0];
  if (user_role === "user") {
    return apiClient.get(
      `${apiClient.Urls.bankinformation}/${user.user_id}`,
      "",
      true
    );
  }
  return apiClient.get(
    user_role !== "officer"
      ? `${apiClient.Urls.adminBankinformation}/${payload}`
      : `${apiClient.Urls.officerBankinformation}/${payload}`,
    "",
    true
  );
};

export const validate_gst = (payload) => {
  var user = LocalStorage.getItem("tata_login_user");
  const vendor_role = user.roles[0];
  return apiClient.post(
    vendor_role === "user"
      ? `${apiClient.Urls.validate_gst}`
      : vendor_role === "officer"
      ? `${apiClient.Urls.validate_gst_officer}`
      : `${apiClient.Urls.validate_gst_admin}`,
    payload,
    true
  );
};

export const submit_vendor_edit_api = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.submit_vendor_edit}/${payload.vendor_id}`,
    payload,
    true
  );
};
